import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const requiredInvitationSearchSchema = z.object({
  organizationId: z.string(),
  invitationCode: z.string(),
});

export const invitationSearchSchema = z.object({
  organizationId: z.string().optional(),
  invitationCode: z.string().optional(),
});

export const Route = createFileRoute('/invitation')({
  validateSearch: (search) => requiredInvitationSearchSchema.parse(search),
  beforeLoad: ({ search, context }) => {
    const isAuthenticated = context.isAuthenticated;

    if (isAuthenticated) {
      throw redirect({
        to: '/organization/join',
        search: {
          organizationId: search.organizationId,
          invitationCode: search.invitationCode,
        },
      });
    }

    throw redirect({ to: '/signup', search });
  },
});
